import { render, staticRenderFns } from "./igt-key-item.vue?vue&type=template&id=765b0b79&scoped=true&"
import script from "./igt-key-item.vue?vue&type=script&lang=js&"
export * from "./igt-key-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765b0b79",
  null
  
)

export default component.exports